export default __webpack_public_path__ + "media/images/portfolio/gallery-01-390x230-2c91cc3de975456e844a0a86085684db.jpg";